module.exports = __webpack_public_path__ + "static/media/app-store-logo.bc34b17a.png";